import { DataDisplayPage } from "@/features/Animals/reproductive-process.tsx";

const dummyData = [
  {
    id: "BR001",
    dgrRecipientCow: "Holstein-001",
    weight: 650,
    bcsD0: "4",
    donorCow: "Elite-Donor-A",
    donorBreed: "holstein",
    bull: "Champion-Bull-X",
    name: "Bella",
    dgrBull: "DGR-Bull-001",
    embryoBreed: "holstein",
    submissionTime: "2024-01-15T08:30:00Z",
    dateET: "1/15/2024",
    entryTime: "8:30 AM",
    status: "Transferred",
  },
  {
    id: "BR002",
    dgrRecipientCow: "Angus-002",
    weight: 580,
    bcsD0: "3",
    donorCow: "Prime-Donor-B",
    donorBreed: "angus",
    bull: "Superior-Bull-Y",
    name: "Luna",
    dgrBull: "DGR-Bull-002",
    embryoBreed: "angus",
    submissionTime: "2024-01-15T09:15:00Z",
    dateET: "1/15/2024",
    entryTime: "9:15 AM",
    status: "Transferred",
  },
  {
    id: "BR003",
    dgrRecipientCow: "Hereford-003",
    weight: 620,
    bcsD0: "4",
    donorCow: "Select-Donor-C",
    donorBreed: "hereford",
    bull: "Premium-Bull-Z",
    name: "Rosie",
    dgrBull: "DGR-Bull-003",
    embryoBreed: "hereford",
    submissionTime: "2024-01-15T10:00:00Z",
    dateET: "1/15/2024",
    entryTime: "10:00 AM",
    status: "Transferred",
  },
  {
    id: "BR004",
    dgrRecipientCow: "Charolais-004",
    weight: 720,
    bcsD0: "5",
    donorCow: "Excellence-Donor-D",
    donorBreed: "charolais",
    bull: "Elite-Bull-W",
    name: "Daisy",
    dgrBull: "DGR-Bull-004",
    embryoBreed: "charolais",
    submissionTime: "2024-01-15T10:45:00Z",
    dateET: "1/15/2024",
    entryTime: "10:45 AM",
    status: "Transferred",
  },
  {
    id: "BR005",
    dgrRecipientCow: "Simmental-005",
    weight: 680,
    bcsD0: "4",
    donorCow: "Quality-Donor-E",
    donorBreed: "simmental",
    bull: "Outstanding-Bull-V",
    name: "Grace",
    dgrBull: "DGR-Bull-005",
    embryoBreed: "simmental",
    submissionTime: "2024-01-15T11:30:00Z",
    dateET: "1/15/2024",
    entryTime: "11:30 AM",
    status: "Transferred",
  },
  {
    id: "BR006",
    dgrRecipientCow: "Limousin-006",
    weight: 590,
    bcsD0: "3",
    donorCow: "Superior-Donor-F",
    donorBreed: "limousin",
    bull: "Champion-Bull-U",
    name: "Sophie",
    dgrBull: "DGR-Bull-006",
    embryoBreed: "limousin",
    submissionTime: "2024-01-15T12:15:00Z",
    dateET: "1/15/2024",
    entryTime: "12:15 PM",
    status: "Pending",
  },
];

function ReproductiveProcessDashboard() {
  return (
    <div>
      <DataDisplayPage data={dummyData} />
    </div>
  );
}

export default ReproductiveProcessDashboard;
